import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    routes: [{
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: '/',
        component: () =>
            import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
        meta: { title: '自述文件' },
        children: [{
            path: '/dashboard',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
            meta: { title: '系统首页' }
        },
        {
            name: 'contentManagement',
            path: '/contentManagement',
            component: () =>
                import('../components/page/copyrightSide/contentCenter/titles/contentManagement.vue'),
            meta: { title: '片源信息' }
        },
        {
            path: '/createContent',
            component: () =>
                import('../components/page/copyrightSide/contentCenter/titles/createContent.vue'),
            meta: { title: '创建片源' }
        },
        {
            path: '/displayContent',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/contentCenter/titles/displayContent.vue'),
            meta: { title: '查看片源' }
        },
        {
            path: '/editContent',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/contentCenter/titles/editContent.vue'),
            meta: { title: '编辑片源' }
        },
        {
            path: '/createShows',
            component: () =>
                import( /* webpackChunkName: "tabs" */ '../components/page/copyrightSide/contentCenter/shows/createShows.vue'),
            meta: { title: '创建节目' }
        },
        {
            path: '/editShows',
            component: () =>
                import( /* webpackChunkName: "tabs" */ '../components/page/copyrightSide/contentCenter/shows/editShows.vue'),
            meta: { title: '编辑节目' }
        },
        {
            path: '/firstEdit',
            component: () =>
                import( /* webpackChunkName: "tabs" */ '../components/page/copyrightSide/contentCenter/shows/firstEdit.vue'),
            meta: { title: '编辑节目' }
        },
        {
            path: '/form',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/contentCenter/shows/BaseForm.vue'),
            meta: { title: '节目管理' }
        },
        {
            path: '/dataOverView',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/data/DataOverView'),
            meta: { title: '数据概览' }
        },
        {
            path: '/cnDataOverView',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/data/cnDataOverView'),
            meta: { title: '数据概览' }
        },
        {
            path: '/movieData',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/data/MovieData'),
            meta: { title: '电影数据' }
        },
        {
            name: 'pubMore',
            path: '/pubMore',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/data/components/pubmore'),
            meta: { title: '更多' }
        },
        {
            path: '/cnMovieData',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/data/cnMovieData'),
            meta: { title: '电影数据' }
        },
        {
            path: '/dramaData',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/data/DramaData'),
            meta: { title: '剧集数据' }
        },
        {
            path: '/cnDramaData',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/data/cnDramaData'),
            meta: { title: '剧集数据' }
        },
        {
            path: '/wxAppDramaData',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/data/wxAppDramaData'),
            meta: { title: '小程序数据' }
        },
        {
            path: '/channelData',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/data/ChannelData'),
            meta: { title: '渠道数据' }
        },
        {
            path: '/copyrightInformation',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/enterpriseInformation/copyrightInformation.vue'),
            meta: { title: '企业认证' }
        },
        {
            path: '/copyrightBankAccount',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/enterpriseInformation/bankAccount.vue'),
            meta: { title: '银行账户' }
        },
        // {
        //     path: '/mySales',
        //     component: () =>
        //         import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/IncomeSettlement/mySales.vue'),
        //     meta: { title: '我的销售' }
        // },
        {
            path: '/settlementCenter',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/IncomeSettlement/settlementCenter.vue'),
            meta: { title: '结算中心' }
        },
        {
            path: '/voucherList',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/copyrightSide/IncomeSettlement/voucherList.vue'),
            meta: { title: '汇款单列表' }
        },

        // {
        //     path: '/testCreateContent',
        //     component: () => import(/* webpackChunkName: "form" */ '../components/page/copyrightSide/contentCenter/titles/testCreateContent.vue'),
        //     meta: { title: '测试上传' }
        // },
        //渠道方
        {
            path: '/contentMarketing',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/contentCenter/contentMarketing.vue'),
            meta: { title: '内容市场' }
        },
        {
            path: '/myProgram',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/contentCenter/myProgram.vue'),
            meta: { title: '我的节目' }
        },
        {
            path: '/myFollow',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/contentCenter/myFollow.vue'),
            meta: { title: '我的关注' }
        },
        {
            path: '/showsDetail',
            name: 'showsDetail',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/contentCenter/showsDetail.vue'),
            meta: { title: '节目详情' }
        },
        {
            path: '/selectedContent',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/contentCenter/selectedContent.vue'),
            meta: { title: '已选内容' }
        },
        {
            path: '/capitalAccount',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/capitalAccount.vue'),
            meta: { title: '资金账户' }
        },
        {
            path: 'offlineRemittance',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/offlineRemittance.vue'),
            meta: { title: '线下汇款' }
        },
        {
            path: 'myOrder',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/myOrder.vue'),
            meta: { title: '我的订单' }
        },
        {
            path: 'accountOrderList',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/accountOrderList.vue'),
            meta: { title: '财务流水' }
        },
        {
            path: 'monthClear',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/monthClear.vue'),
            meta: { title: '订单详情' }
        },
        {
            path: 'submitRemittanceInformation',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/submitRemittanceInformation.vue'),
            meta: { title: '提交汇款信息' }
        },

        {
            path: 'playCodeDetail',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/playCodeDetail.vue'),
            meta: { title: '播放码明细' }
        },
        {
            path: 'editRemittanceInformation',
            name: 'editRemittanceInformation',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/editRemittanceInformation.vue'),
            meta: { title: '编辑汇款信息' }
        },
        {
            path: '/shoppingCart',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/shoppingCart.vue'),
            meta: { title: '订单生成' }
        },
        {
            path: '/payOrder',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/channelSide/moneyManagement/payOrder.vue'),
            meta: { title: '立即付款' }
        },
        {
            path: '/channelInformation',
            component: () =>
                import('../components/page/channelSide/enterpriseInformation/channelInformation'),
            meta: { title: '企业认证' }
        },
        {
            path: '/channelBankAccount',
            component: () =>
                import('../components/page/channelSide/enterpriseInformation/bankAccount'),
            meta: { title: '银行账户' }
        },
        {
            path: '/userManagement',
            component: () =>
                import( /* webpackChunkName: "permission" */ '../components/page/channelSide/currency/userManagement'),
            meta: { title: '用户管理' }
        },
        {
            path: '/roleManagement',
            component: () =>
                import( /* webpackChunkName: "permission" */ '../components/page/channelSide/currency/roleManagement'),
            meta: { title: '角色管理' }
        },
        {
            path: '/404',
            component: () =>
                import( /* webpackChunkName: "form" */ '../components/page/404.vue'),
            meta: { title: '正在开发' }
        },

        {
            // 权限页面
            path: '/permission',
            component: () =>
                import( /* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
            meta: { title: '权限测试', permission: true }
        },
        {
            path: '/404',
            component: () =>
                import( /* webpackChunkName: "404" */ '../components/page/404.vue'),
            meta: { title: '404' }
        },
        {
            path: '/403',
            component: () =>
                import( /* webpackChunkName: "403" */ '../components/page/403.vue'),
            meta: { title: '403' }
        },
        ]
    },
    // {
    //     path: '/C/userList',
    //     component: () => import(/* webpackChunkName: "403" */ '../components/page/C/userList/index'),
    //     meta: { title: '用户列表' }
    // },
    {
        path: '/login',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/Login.vue'),
        meta: { title: '登录' }
    },
    {
        path: '/pdsLogin',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/pdsLogin.vue'),
        meta: { title: 'pds登录' }
    },
    {
        path: '/changePassword',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/changePassword.vue'),
        meta: { title: '忘记密码' }
    },
    {
        path: '/index',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/index.vue'),
        meta: { title: '首页' }
    },
    {
        path: '/copyrightJoin',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/copyrightJoin.vue'),
        meta: { title: '版权方入驻' }
    },
    {
        path: '/channelJoin',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/channelJoin.vue'),
        meta: { title: '渠道方入驻' }
    },
    {
        path: '/test',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/test.vue'),
        meta: { title: 'test' }
    },
    {
        path: '*',
        redirect: '/404'
    }
    ]
});